// Session-scoped player settings — runtime toggles, not tunables (T is for
// numbers the dev panel sweeps; these are choices the player flips in play).
// Module-level so they survive respawn (the player entity is replaced on
// death). Not persisted to the save yet — add to persistence.ts if a setting
// earns cross-session memory.

export const settings = {
  /** Auto-attack (R / R3): fire whenever the aim assist holds a soft-locked
   *  target. Only meaningful with heading aim — cursor aim never locks. */
  autoFire: false,
}
